/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_b64_url_safe = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL-safe`)
};

const es_b64_url_safe = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguro para URL`)
};

const de_b64_url_safe = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL-sicher`)
};

const nl_b64_url_safe = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL-veilig`)
};

const fr_b64_url_safe = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sûr pour les URL`)
};

const it_b64_url_safe = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL-safe`)
};

const pt_br2_b64_url_safe = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguro para URL`)
};

const pt_b64_url_safe = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguro para URL`)
};

const ja_b64_url_safe = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL-safe`)
};

const zh_b64_url_safe = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL 安全`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const b64_url_safe = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.b64_url_safe(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("b64_url_safe", locale)
	if (locale === "en") return en_b64_url_safe(inputs)
	if (locale === "es") return es_b64_url_safe(inputs)
	if (locale === "de") return de_b64_url_safe(inputs)
	if (locale === "nl") return nl_b64_url_safe(inputs)
	if (locale === "fr") return fr_b64_url_safe(inputs)
	if (locale === "it") return it_b64_url_safe(inputs)
	if (locale === "pt-BR") return pt_br2_b64_url_safe(inputs)
	if (locale === "pt") return pt_b64_url_safe(inputs)
	if (locale === "ja") return ja_b64_url_safe(inputs)
	return zh_b64_url_safe(inputs)
};